module.exports = {
          srcSet: __webpack_public_path__ + "public/images/38340c7f92f1b00fd99d0a1bf8cd951a-1200.jpg"+" 1200w",
          images:[ {path: __webpack_public_path__ + "public/images/38340c7f92f1b00fd99d0a1bf8cd951a-1200.jpg",width: 1200,height: 800}],
          src: __webpack_public_path__ + "public/images/38340c7f92f1b00fd99d0a1bf8cd951a-1200.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/38340c7f92f1b00fd99d0a1bf8cd951a-1200.jpg"},
          
          width: 1200,
          height: 800
        }